import {
  Battery0Bar as Battery0BarIcon,
  Battery1Bar as Battery1BarIcon,
  Battery2Bar as Battery2BarIcon,
  Battery3Bar as Battery3BarIcon,
  Battery4Bar as Battery4BarIcon,
  BatteryChargingFull as BatteryChargingFullIcon,
  BatteryFull as BatteryFullIcon,
  BatteryUnknown as BatteryUnknownIcon,
} from '@mui/icons-material';
import { Tooltip } from '@mui/material';

function Icon({ percentage, charging, ...props }) {
  if (charging) {
    return <BatteryChargingFullIcon {...props} />;
  }

  const roundedValue = Math.round(percentage / 20) * 20;

  switch (roundedValue) {
    case 0:
      return <Battery0BarIcon {...props} />;
    case 20:
      return <Battery1BarIcon {...props} />;
    case 40:
      return <Battery2BarIcon {...props} />;
    case 60:
      return <Battery3BarIcon {...props} />;
    case 80:
      return <Battery4BarIcon {...props} />;
    case 100:
      return <BatteryFullIcon {...props} />;
    default:
      return <BatteryUnknownIcon {...props} />;
  }
}

function getBatteryColor(percentage, charging) {
  if (charging) {
    return 'info.main';
  }

  if (percentage > 50) {
    return 'success.main';
  }

  if (percentage < 20) {
    return 'error.main';
  }

  return 'warning.main';
}

export function BatteryLevelIcon({ percentage, charging }) {
  return percentage !== null && percentage !== undefined ? (
    <Tooltip title={`${charging ? 'Charging ' : ''}${Math.round(percentage)}%`}>
      <Icon
        percentage={percentage}
        charging={charging}
        sx={{
          fontSize: 16,
          color: getBatteryColor(percentage, charging),
        }}
      />
    </Tooltip>
  ) : null;
}
